// BlinkingCursor.tsx – A simple CSS-only blinking caret for streaming messages.
import React from 'react';

/**
 * Renders a thin blinking cursor at the end of streaming text.
 * Pure CSS animation — no JS timers needed.
 */
const BlinkingCursor: React.FC = () => (
    <span className="blinking-cursor" aria-hidden="true">▍</span>
);

export default React.memo(BlinkingCursor);
